import React, { lazy, Suspense } from "react";

import DefaultLoader from "../../utilities/loaders/DefaultLoader";
const PendingReceiptApprovalsContent = lazy(
  () => import("./PendingReceiptApprovalsContent"),
);

const PendingReceiptApprovals = () => {
  return (
    <Suspense fallback={<DefaultLoader />}>
      <PendingReceiptApprovalsContent />
    </Suspense>
  );
};

export default PendingReceiptApprovals;
